import { useEffect, useState } from 'react';
import * as api from './api';
import { initialsOf, firstNameOf } from './format';

// The people you can filter by: yourself first, then your trusted connections in
// the order the API already sorts them. Ids are stable user ids, never names.
export const usePeople = (user, active) => {
  const [people, setPeople] = useState([]);

  useEffect(() => {
    if (!active || !user?.id) return;
    let cancelled = false;
    api
      .getMyConnections()
      .then((connections) => {
        if (cancelled) return;
        // First names read best, but two Anas - or an Ana next to your own
        // "You" chip - must stay tellable apart.
        const firstNames = [
          firstNameOf(user.name).toLowerCase(),
          ...connections.map((c) => firstNameOf(c.name).toLowerCase()),
        ];
        const label = (name) => {
          const first = firstNameOf(name);
          const clashes = firstNames.filter((n) => n === first.toLowerCase()).length > 1;
          return clashes ? name : first;
        };
        const sorted = connections
          .map((c) => ({
            id: c.id,
            label: label(c.name),
            name: c.name,
            initials: c.initials,
          }))
          // Alphabetical by the name actually shown, which is not always the
          // full name the API sorted on.
          .sort((a, b) => a.label.localeCompare(b.label));
        setPeople([
          { id: user.id, label: 'You', name: user.name, initials: initialsOf(user.name) },
          ...sorted,
        ]);
      })
      .catch(() => {
        // The person filter is an enhancement; the feed itself still loads.
      });
    return () => {
      cancelled = true;
    };
  }, [active, user?.id, user?.name]);

  return people;
};
